import './App.css';
import Routers from './Routes';

function App() {
  return (
    <div className='App'>
      <Routers />
    </div>
  )
}

export default App;